<template>
    <section :class="css.container" ref="container">
        <!-- * 头部信息 -->
        <div :class="css.header">
            <div class="container" :class="css.header_body">
                <div :class="css.title" class="font-variable color-1 font-bold">{{ $t("DiseaseModel") }}</div>
                <UiTooltip :zIndex="68" :width="600" direction="bottom" align="start" :classExtraName="css_normalize.tip">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/images/disease/mark.png" alt="" />
                    <template #content>
                        <div :class="css_normalize.context">{{ $t("DiseaseModelDesc1") }}</div>
                        <div :class="css_normalize.context">{{ $t("DiseaseModelDesc2") }}</div>
                    </template>
                </UiTooltip>
            </div>
        </div>

        <div :class="css.body" class="container" v-loading="loading">
            <div class="text-hint" v-if="!exist">{{ $t("Placeholder.UncollectedData") }}</div>
            <template v-else>
                <div :class="css.controls">
                    <default-search v-model="keyword" :width="376" @search="methods.search" :clearable="true" />
                </div>

                <!-- * 表格 -->
                <ui-table2 :class="css.table" :data="data" :option="option" :error="$t('NoDataAvailable')" @sort="methods.sort">
                    <template #MGI="{ data }">
                        <span v-if="!data.MGI">--</span>
                        <ProjectRoute v-else :class="css_normalize.assets" :to="`https://www.informatics.jax.org/allele/MGI:${data.MGI}`">
                            {{ data.MGI }}
                        </ProjectRoute>
                    </template>

                    <template #name="{ data }">
                        <span v-if="!data.name">--</span>
                        <ProjectRoute v-else v-html="data.name" :class="css_normalize.assets" :to="{ name: 'Model', params: { id: data.MGI } }" />
                    </template>

                    <template #genes="{ data }">
                        <template v-if="!data.genes?.length">--</template>
                        <template v-else>
                            <div :class="css.genes" v-for="value in data.genes">
                                <ProjectRoute :class="css_normalize.assets" :to="{ name: 'Gene', params: { id: value.id } }">
                                    {{ value.name }}
                                </ProjectRoute>
                            </div>
                        </template>
                    </template>
                </ui-table2>

                <ui-pagination :class="css.pagination" v-model="page" :count="count" @change="methods.acquire()">
                    <template #items> {{ $t("Layout.PaginationDetails", { count: count, limit: 10 }) }}</template>
                </ui-pagination>
            </template>
        </div>
    </section>
</template>

<script lang="ts" setup>
//* 组件库
import { UiPagination, UiTable2, UiTooltip } from "various-ui";
//* 公共组件
import { DefaultSearch } from "@/components/controls";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";
import css_normalize from "@/assets/style/src/index.module.less";

//* 组合函数
const { refs, nodes, option, methods } = useComposable();
const { data, page, exist, count, loading, keyword } = refs;
const { container } = nodes;
const { render, hidden } = methods;

//* 组件属性导出
defineExpose({ render, hidden });
</script>
